/* ============================================================================
   SUNNY STRIPES — COMMERCIAL ON THE INSTANT QUOTE                added 2026-10-09
   ----------------------------------------------------------------------------
   THERE ARE NO PRICES IN THIS FILE.

   THE PROBLEM IT FIXES
   The instant quote has a Home / Business toggle, but until now it only
   changed the card descriptions and the FAQ - a business was quoted
   residential mowing. Meanwhile /pages/maintenance priced the same property
   with the commercial rates in ss-rates.js (COMMERCIAL.mowSlope and mowMin),
   so one property got two prices depending on the page.

   WHAT IT DOES, Carl's call 2026-10-09
   1. Points businesses at the maintenance builder. The existing "comMsg"
      banner under the toggle now links to /pages/maintenance, which is the
      page built for them: traced turf and beds, a whole-season program,
      monthly invoices, a site walk above three acres.
   2. Anyone who stays here is priced at the commercial mowing rate - the same
      SS_RATES.mowPerVisit(acres, true) the maintenance builder uses. Below the
      last curve point that is the residential curve with a $75 floor; above it
      the steeper commercial slope.
   3. No online checkout for commercial - see ss-book-now.js. The products are
      residential prices, and a commercial job needs a certificate of insurance
      and an invoice to the property manager first.

   EVERY-OTHER-WEEK. The maintenance builder (comProgram in ss-rates.js) does
   not apply the residential 30% biweekly premium to commercial mowing, so
   neither does this - one property, one price. If commercial biweekly should
   carry the premium, change comProgram and this together.

   WRAPPING ORDER. ss-instant-quote-rates.js replaces v19's mowPerVisit (and
   marks it __ssFreq). If this wrapped first, that file would then wrap over
   it and the commercial rate would vanish, so this waits for that mark.
   ============================================================================ */
(function () {
  "use strict";

  var MAINT_URL = "/pages/maintenance";

  function ready() {
    return typeof S !== "undefined" && S && window.SS_RATES &&
           typeof window.mowPerVisit === "function" && window.mowPerVisit.__ssFreq &&
           typeof window.propType === "function" && typeof window.calc === "function";
  }

  function commercial() { return S.propType === "commercial"; }

  function hook() {
    var SS = window.SS_RATES;

    if (!window.mowPerVisit.__ssCom) {
      var resMPV = window.mowPerVisit;
      var comMPV = function () {
        if (commercial()) {
          try {
            var a = typeof acresOf === "function" ? acresOf() : null;
            if (a != null && a > 0) {
              var v = SS.mowPerVisit(a, true);
              if (isFinite(v) && v > 0) return v;
            }
          } catch (e) {}
        }
        return resMPV.apply(this, arguments);
      };
      comMPV.__ssFreq = true;
      comMPV.__ssCom = true;
      window.mowPerVisit = comMPV;
    }

    /* v19's toggle redraws the cards and FAQ but not the prices. */
    if (!window.propType.__ssCom) {
      var origPT = window.propType;
      var pt = function () {
        var r = origPT.apply(this, arguments);
        try { window.calc(); } catch (e) {}
        return r;
      };
      pt.__ssCom = true;
      window.propType = pt;
    }

    var msg = document.getElementById("comMsg");
    var span = msg && msg.querySelector("span");
    if (span) {
      span.innerHTML =
        "<b>Pricing a business, HOA or campus?</b> Our " +
        '<a href="' + MAINT_URL + '" style="color:#235029;font-weight:800;text-decoration:underline">' +
        "grounds program builder</a> lets you trace your turf and beds and prices a full " +
        "season on monthly invoices. Or keep going here &mdash; commercial rates apply, " +
        "and we confirm everything with you before anything is billed.";
    }
  }

  var tries = 0;
  var t = setInterval(function () {
    if (ready()) {
      clearInterval(t);
      hook();
      try { window.calc(); } catch (e) {}
      return;
    }
    if (++tries > 120) clearInterval(t);
  }, 50);
})();
